<table class="skill-grid">
    <thead>
        <tr>
            <td>
                <label class="label">Skill</label>
            </td>
            <td>
                <label class="label">{{employeeUser?.PreferredName || employeeUser?.FirstName}} says</label>
            </td>
            <td>
                <label class="label"> {{supervisorUser?.PreferredName || supervisorUser?.FirstName}} says</label>
            </td>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let skillQuestion of employeeReviewAnalysis?.skillQuestions; let i = index">
            <tr  class="detail-row" [ngClass]="{ 'detail-row-even': i % 2 == 0 }">
                <td>
                    <i class="fa fa-plus hide-on-print" (click)="toggleExpansion(skillQuestion, true)" [hidden]="expanded[skillQuestion?.question?.EmployeeReviewQuestionId]"></i>
                    <i class="fa fa-minus hide-on-print" (click)="toggleExpansion(skillQuestion, false)" [hidden]="!expanded[skillQuestion?.question?.EmployeeReviewQuestionId]"></i>
                    
                    {{skillQuestion.question?.EmployeeReviewQuestionSkillIdDisplay}}
                </td>
                <td>
                    {{skillQuestion.employeeDisplay}}
                </td>
                <td>
                    {{skillQuestion.supervisorDisplay}}
                </td>
            </tr>
            <tr  class="detail-row hide-on-print" [ngClass]="{ 'detail-row-even': i % 2 == 0 }" [hidden]="!expanded[skillQuestion?.question?.EmployeeReviewQuestionId]">
                <td colspan="3">
                    {{skillQuestion.question?.Question}}
                </td>
            </tr>
        </ng-container>

    </tbody>
</table>

<div class="skill-grid2" *ngIf="false">
    <div dwRow class="skill-header">
        <div dwCol="4">
            <label class="label">Skill</label>
        </div>
        <div dwCol="4">
            <label class="label">{{employeeUser?.PreferredName || employeeUser?.FirstName}} says</label>
        </div>
        <div dwCol="4">
            <label class="label"> {{supervisorUser?.PreferredName || supervisorUser?.FirstName}} says</label>
        </div>
    </div>
    <div dwRow *ngFor="let skillQuestion of employeeReviewAnalysis?.skillQuestions" class="skill-row">
        <div dwCol="4">
            {{skillQuestion.question?.EmployeeReviewQuestionSkillIdDisplay}}
        </div>
        <div dwCol="4">
            {{skillQuestion.employeeDisplay}}
        </div>
        <div dwCol="4">
            {{skillQuestion.supervisorDisplay}}
        </div>
    </div>
</div>
